import * as Yup from "yup";
import {
  richCard,
  replies,
  actions,
  carrousel,
} from "../../../../components/campaigns/rcs/validationSchema";
export const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("El nombre del template es requerido")
    .min(5, "Mínimo 5 caracteres")
    .max(100, "Máximo 100 caracteres"),
  rcsmessage: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(2000, "El mensaje no puede tener más de 2000 caracteres")
    .test(
      "required-rcsmessage",
      "El mensaje rcs es requerido",
      function (value) {
        return this.parent.step !== 3 ? !!value : true;
      },
    ),
  category: Yup.string().required("La categoría es requerida"),
  status: Yup.boolean().required("El status es requerido"),
  title_rcs_message: Yup.string()
    .test(
      "required-title_rcs_message",
      "El título es requerido",
      function (value) {
        return this.parent.step === 2 ? !!value : true;
      },
    )
    .min(3, "El título rcs debe tener al menos 3 caracteres")
    .max(200, "El título rcs no puede tener más de 200 caracteres")
    .nullable(),
  fallback: Yup.string()
    .min(3, "El mensaje debe tener al menos 3 caracteres")
    .max(398, "El mensaje no puede tener más de 399 caracteres")
    .required("El mensaje fallback es requerido"),
  parameters: Yup.string().nullable(),
  ...richCard,
  ...replies,
  ...actions,
  ...carrousel,
});
